import React from 'react';
import {Redirect} from 'react-router';
import paths from '../../routes/paths';

const Overview = () => <Redirect to={paths.WALLET} />;

export default Overview;
